define(function (require, exports, module) {
    var PatchWorker = require('game-data-patch/game-data-patch');
    var undef;

    function ApiItemModels () {

    };

    ApiItemModels.prototype = {
        newData: true
    };

    function ApiItemModelCache ($gameID) {
        this.gameID = $gameID;
        this.data = new ApiItemModels();
    }

    ApiItemModelCache.prototype = {
        gameID: null,
        patchClient: null,
        patchQC: true,

        applyNewData: function ($data) {
            var isPatch = $data.isPatch === true;
            this.patchQC = true;
            this.patched = isPatch;
            /* eslint eqeqeq: "off" */
            if (!isPatch && $data.metaData == undef) {
                // bad data, start over please
                this.patchQC = false;
                this.data.newData = false;
                this.patchClient = null;
                this.patched = false;
                return;
            }

            if (!isPatch) {
                this.setAllData($data);
            } else if (isPatch && $data.diffs.length) {
                this.applyPatch($data);
            } else {
                // No changes to apply
                // we should be ok
                this.data.newData = false;
            }
        },

        applyPatch: function ($data) {
            var tempData = this.patchClient.patch($data.diffs);
            var data = this.data;
            this.patchQC = tempData.success;

            if (this.patchQC) {
                data.api = $data.create(tempData.data);
                data.newData = true;
            } else {
                // if failed null out the patch client to start over
                data.newData = false;
                this.patchClient = null;
                this.patched = false;
            }
        },

        setAllData: function ($data) {
            this.data.newData = true;
            this.data.api = $data;
            this.patchClient = new PatchWorker($data.dataString);
        }
    };

    return ApiItemModelCache;
});
